import { useEffect, useState } from 'react';
import employeesApi from 'Api/axios/employees-api';
import type { AchievementProgressI } from 'types';

/**
 * Logros del empleado.
 *
 * Una sola llamada donde antes había cuatro consultas de GraphQL en paralelo
 * unidas por `Promise.all`.
 */
const useEmployeeAchievements = (employeeId?: string) => {
  const [achievements, setAchievements] = useState<AchievementProgressI[]>([]);

  useEffect(() => {
    if (!employeeId) return;

    employeesApi.readAchievements(employeeId).then(response => {
      setAchievements(response.data ?? []);
    });
  }, [employeeId]);

  const earned = achievements.filter(achievement => achievement.completed).length;

  return { achievements, earned, total: achievements.length };
};

export default useEmployeeAchievements;
